// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"7e28f8e8","533":"e8c09331","743":"33490eaf","849":"9bd92aeb","970":"1f7f2171"}[chunkId] + ".chunk.js";
};